module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAFVBMVEUgRoy3PEghRouottKuHCjgp6z////2S0q7AAAAAnRSTlPU/snCEjgAAAA3SURBVEjH7csxAQAgEMSws4AFLGABC1jAv4TX0PmaPVlYLmaxWErLw/Ixi8VSWg6WjVksltLCDabgYsiD0xdmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/nl.png
// module id = mUiq
// module chunks = 0